import React, { useState } from "react";
import Main from "./components/Main/Main";
import Nav from "./components/Nav/Nav";

const App = () => {
  const [dark, setDark] = useState(false);
  const [search, setSearch] = useState("fish");
  return (
    <div className={`${dark ? "dark" : ""} `}>
      <div className=" transition-all duration-500 min-h-screen bg-slate-100 dark:bg-slate-600 dark:text-white">
        <Nav setDark={{ dark, setDark }} setSearch={setSearch} />
        <Main search={search} />
      </div>
    </div>
  );
};

export default App;
